import '../css/linearicons.css';
import '../css/font-awesome.min.css';
import '../css/bootstrap.css';
import '../css/magnific-popup.css';
import '../css/nice-select.css';
import '../css/animate.min.css';
import '../css/owl.carousel.css';
import '../css/main.css';
import '../css/home.css';
import Carousel from './uiComponents/carousel';
import LoadingOverlay from './uiComponents/loading';
import { useEffect, useState } from 'react';
import CookieConsentBanner from './uiComponents/cookieConsentBanner';
import map from '../img/map.png'; // Importing a placeholder image for the map
import map_mobile from '../img/map_mobile.png'; // Importing a placeholder image for the map on mobile
const Home = () => {
    const [isMapLoading, setIsMapLoading] = useState(true); // State to track map loading
    const [hasConsent, setHasConsent] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('userConsent');
        if (consent === 'accepted') {
            setHasConsent(true);
        }
    }, []);

    const handleMapLoad = () => {
        setIsMapLoading(false); // Set loading to false when the iframe is loaded
    };

    // Determine which map image to use based on screen width
    const [mapSrc, setMapSrc] = useState(map);

    useEffect(() => {
        const updateMapSrc = () => {
            if (window.innerWidth < 1000) {
                setMapSrc(map_mobile);
            } else {
                setMapSrc(map);
            }
        };
        updateMapSrc();
        window.addEventListener('resize', updateMapSrc);
        return () => window.removeEventListener('resize', updateMapSrc);
    }, []);

    return (
        <main className='main-container' >
            <Carousel />
            <section className="video-sec-area pb-100 about-section" id="about">
                <div className="container">
                    <div className="row justify-content-start align-items-center">
                        <div className="col-lg-6 video-right justify-content-center align-items-center d-flex">
                        </div>
                        <article className="col-lg-6 video-left">
                            <header>
                                <h1>
                                    About us
                                </h1>
                            </header>
                            <p>
                                Welcome to Baptist Church Alkapoor— a Christ-centered, Bible-believing community committed to spreading the love and truth of Jesus Christ. Located in Alkapoor Township, we are a family of believers who gather for Worship, Fellowship, and Sunday Church Service at 11:00 am.

                                Our mission is simple: to know Christ and make Him known. We believe in the authority of Scripture, the power of prayer, and the importance of sharing the Gospel with all people. Whether you're new to the faith, seeking answers, or looking for a church home, you are welcome here.

                                We look forward to walking this journey of faith with you!
                            </p>
                        </article>
                    </div>
                </div>
            </section>
            <section className="gallery-area section-gap" id="location" style={{ position: 'relative' }}>
                <div className="container">
                    <div className="row d-flex justify-content-center">
                        <header className="menu-content pb-60 col-lg-10">
                            <div className="title text-center">
                                <h1 className="mb-10">Location</h1>
                            </div>
                        </header>
                        <figure style={{ position: 'relative', width: '100%', height: '450px' }}>
                            {isMapLoading && hasConsent && <LoadingOverlay />} {/* Show loading overlay while map is loading */}
                            {hasConsent ? (
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121836.1495050383!2d78.22296054335942!3d17.393557800000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb952cdc5d458b%3A0x6d84e53502e9ae16!2sBaptist%20Church%20Alkapoor!5e0!3m2!1sen!2sin!4v1745321117862!5m2!1sen!2sin"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="maps"
                                    onLoad={handleMapLoad}
                                ></iframe>
                            ) : (
                                <div className="placeholder-map-wrapper">
                                    <a
                                        href="https://maps.app.goo.gl/Ph6ERNiFsZHSeyn39"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="placeholder-map-link"
                                    >
                                        <img
                                            src={mapSrc}
                                            alt="Map Placeholder"
                                            className="placeholder-map"
                                            title="Enable cookies to view embedded Google Map"
                                        />
                                        <div className="placeholder-map-overlay">
                                            <div className="placeholder-map-text">
                                                Map preview — Click to open Google Maps<br />
                                                or enable cookies to view embedded map
                                            </div>
                                            <div className="google-copyright">
                                                Map image © Google
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            )}


                            <figcaption className='sr-only'>Alkapoor Baptist Church Google Map Location</figcaption>
                        </figure>
                    </div>

                </div>
            </section>
            <CookieConsentBanner onAccept={() => setHasConsent(true)} />
        </main>
    );
};

export default Home;